<script lang="ts">
	import { DataHandlerDevice, type DeviceGroup, type Device, DeviceRPi } from "luxedo-data"
	import ProjectorGroupCircle from "./ProjectorGroupCircle.svelte"
	import { Reactivity } from "luxedo-reactivity"

	interface Props {
		group: DeviceGroup
		onClick?: () => void
	}

	let { group, onClick }: Props = $props()

	$effect.pre(() => {
		Reactivity.useProps(group, ["childDevices"])
	})

	let childDevices: Array<DeviceRPi> = $derived(Reactivity.propOf(group, "childDevices"))
</script>

<div class="projector-icon">
	{#if childDevices.length > 0}
		{#each childDevices as child}
			<ProjectorGroupCircle deviceColor={child.color} />
		{/each}
	{:else}
		<ProjectorGroupCircle deviceColor={"var(--color-main-transparent)"} />
	{/if}
</div>

<style>
	div {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		max-width: 2.5rem;
		max-height: 2.5rem;
	}

	div :global(svg) {
		flex: 1;
	}
</style>
